import { Box, Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { colors } from "../../constants/design.constants";

export const StatusTag: React.FC<{
  children: any;
  type: "completed" | "warning" | "error" | "failure" | "queued" | null;
  style?: any;
  hidden?: boolean;
}> = (props: any) => {
  const { type, children, style } = props;

  const [indicatorProps, setIndicatorProps] = useState({} as any);

  const indicatorColor = () => {
    if (type === "completed" || type === "success") {
      setIndicatorProps({
        indicator: colors.success,
        text: colors.success,
        bg: colors.successMuted,
      });
      return;
    }

    if (type === "error" || type === "failure") {
      setIndicatorProps({
        indicator: colors.danger,
        text: colors.danger,
        bg: colors.dangerMuted,
      });
      return;
    }

    if (type === "cancelled" || type === "warning") {
      setIndicatorProps({
        indicator: colors.warning,
        text: colors.warning,
        bg: colors.warningMuted,
      });
      return;
    }

    if (!children) {
      setIndicatorProps({
        indicator: colors.warning,
        text: colors.warning,
        bg: colors.warningMuted,
      });
      return;
    }

    setIndicatorProps({
      indicator: colors.textTertiary,
      text: colors.textSecondary,
      bg: colors.hover,
    });
  };

  useEffect(() => {
    indicatorColor();
  }, [type]);

  return (
    <BaseTag
      pb="5px"
      hidden={props.hidden}
      color={indicatorProps.text}
      bg={indicatorProps.bg}
      width="80px"
      border={`1px solid ${indicatorProps.indicator}33`}
    >
      <Flex flexDirection="row" alignItems="center" gap={1.5}>
        <Box
          {...style}
          bg={indicatorProps.indicator}
          w="5px"
          h="5px"
          fontSize="12px"
          borderRadius="0"
        />
        {!children ? "Pending" : children}
      </Flex>
    </BaseTag>
  );
};

const BaseTag = styled(Box)({
  borderRadius: "2px",
  padding: "3px 8px",
  fontWeight: 500,
  fontSize: "11px",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  fontFamily: '"IBM Plex Mono", ui-monospace, monospace',
});
